import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "textlimit"
};
const _hoisted_2 = {
  class: "form-item mt16"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_style = _resolveComponent("font-style");
  const _component_gpickr = _resolveComponent("gpickr");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_form_item = _resolveComponent("el-form-item");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_font_style, {
    title: $data.fontname,
    value: $data.defaultfont,
    onFontStyle: $options.fontChange
  }, null, 8, ["title", "value", "onFontStyle"]), (_openBlock(), _createBlock(_component_gpickr, {
    title: "文字背景",
    color: $data.fill,
    onColor: _cache[0] || (_cache[0] = $event => $options.colorHandle($event, 'fill')),
    key: new Date().toString()
  }, null, 8, ["color"])), (_openBlock(), _createBlock(_component_gpickr, {
    title: "文字描边",
    color: $data.stroke,
    onColor: _cache[1] || (_cache[1] = $event => $options.colorHandle($event, 'stroke')),
    key: new Date().toString()
  }, null, 8, ["color"])), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
    modelValue: $data.limit.flag,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.limit.flag = $event),
    label: "字数限制",
    onChange: $options.limitChange
  }, null, 8, ["modelValue", "onChange"]), _withDirectives(_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("span", null, "行数", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.limit.rows,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.limit.rows = $event),
      "controls-position": "right",
      onChange: $options.limitChange
    }, null, 8, ["modelValue", "onChange"])]),
    _: 1
  }), _createVNode(_component_el_form_item, null, {
    label: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createElementVNode("span", null, "每行字数", -1)]))]),
    default: _withCtx(() => [_createVNode(_component_el_input_number, {
      modelValue: $data.limit.len,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.limit.len = $event),
      "controls-position": "right",
      onChange: $options.limitChange
    }, null, 8, ["modelValue", "onChange"])]),
    _: 1
  })], 512), [[_vShow, $data.limit.flag]])])]);
}